import { Pipe, PipeTransform } from '@angular/core';
import { SvgUtils } from '../utils/SvgUtils';
import { IShape } from '../interfaces';
import { ColorUtils } from '@cinetixx/cinetixx-ui';
import { ShapeSeatTypes } from '../enums';
import { ElementTypes } from '../enums/ElementTypes';
import { DEFAULT_SEAT_COLOR } from '../constants';

@Pipe({
  name: 'svgToBase64Bg',
})
export class SvgToBase64BgPipe implements PipeTransform {

  public transform(shape: IShape, color: string): string {
    let svg: string;

    if (shape.shapeSeatType !== ShapeSeatTypes.NONE) {
      const color2 = ColorUtils.adjustColor(color, 20);
      const color3 = ColorUtils.adjustColor(color, 80);

      if (shape.shapeSeatType === ShapeSeatTypes.SEAT && !shape.loveSeatId) {
        svg = SvgUtils.getNormalFreeSeatSvg(color, color2, color3);
      } else if (shape.shapeSeatType === ShapeSeatTypes.NORMAL_CHAIR) {
        svg = this.getNormalChairSvg(color);
      } else if (shape.shapeSeatType === ShapeSeatTypes.DISABLED) {
        svg = SvgUtils
          .getDisabledFreeSeatSvg(color, color2, color3, ColorUtils.isLightColor(color) ? 'black' : 'white');
      } else if (shape.shapeSeatType === ShapeSeatTypes.SEAT_WITH_FOOTSTOOL) {
        svg = SvgUtils.getSeatWithFootstoolSvg(color, color2, color3);
      } else if (shape.shapeSeatType === ShapeSeatTypes.LOVE_SEAT_LEFT) {
        svg = SvgUtils.getLoveLeftFreeSeatSvg(color, color2, color3);
      } else if (shape.shapeSeatType === ShapeSeatTypes.LOVE_SEAT_RIGHT) {
        svg = SvgUtils.getLoveRightFreeSeatSvg(color, color2, color3);
      } else if (shape.shapeSeatType === ShapeSeatTypes.SEAT && shape.loveSeatId) {
        svg = SvgUtils.getLoveInnerFreeSeatSvg(color, color2, color3);
      }
    } else {
      svg = this.getVisualElementSvg(shape.shapeElementType, color);
    }

    const encoded = encodeURIComponent((svg ?? '').trim())
      .replace(/'/g, '%27')
      .replace(/"/g, '%22');

    return `url("data:image/svg+xml,${encoded}")`;
  }

  private getNormalChairSvg(color: string): string {
    if (!color || color.toUpperCase() === DEFAULT_SEAT_COLOR.toUpperCase()) {
      return SvgUtils.getNormalChairSvg();
    }

    return SvgUtils.getNormalChairSvg(
      ColorUtils.adjustColor(color, 45),
      color,
      ColorUtils.adjustColor(color, -35)
    );
  }

  private getVisualElementSvg(elementType: ElementTypes | undefined, color: string): string {
    switch (elementType) {
      case ElementTypes.SCREEN:
        return SvgUtils.getScreenSvg(color);
      case ElementTypes.ROUND_TABLE:
        return SvgUtils.getRoundTableSvg();
      case ElementTypes.SQUARE_TABLE:
        return SvgUtils.getSquareTableSvg();
      case ElementTypes.ENTRANCE_EXIT:
        return SvgUtils.getEntranceExitSvg();
      case ElementTypes.STAIRCASE:
        return SvgUtils.getStaircaseSvg();
      default:
        return '';
    }
  }
}
